import Link from 'next/link';
import Colors from '@domain/constant/colors';
import { AccaRouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from '../introduce.module.scss';
const cx = classnames.bind(styles);

const Arrow = () => {
  return (
    <svg
      className={cx('arrowWrap')}
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.14153 0.387753C0.883377 0.142504 0.475286 0.152969 0.230038 0.411126C-0.0152104 0.669283 -0.00474573 1.07737 0.253411 1.32262L4.02732 4.90782L0.253411 8.49302C-0.00474573 8.73826 -0.0152104 9.14635 0.230038 9.40451C0.475286 9.66267 0.883377 9.67313 1.14153 9.42789L5.40383 5.37872C5.40906 5.37382 5.41424 5.36881 5.41934 5.3637C5.6659 5.11735 5.67229 4.7179 5.43085 4.46376C5.42753 4.46026 5.42417 4.4568 5.42078 4.45339M1.14153 0.387753L5.4038 4.43689L1.14153 0.387753Z"
        fill={Colors.C_COOL_GRAY_80}
      />
    </svg>
  );
};

const ResultLink = () => {
  return (
    <div className={cx('resultLinkWrap')}>
      <div className={cx('resultLinkArea')}>
        <div className={cx('resultLink')}>
          <span className={cx('resultLinkDesc')}>나만의 역량은 과연 무엇일까!</span>
          <div className={cx('resultLinkTitleWrap')}>
            <span className={cx('resultLinkTitle')}>
              <span className={cx('textEmphasis')}>역검</span> 리포트
              <br />
              지금 바로 확인하기
            </span>
          </div>
          <Link href={AccaRouteUrl.ACCA_TEST_GATE} legacyBehavior>
            <a className={cx('link')} role="button">
              확인하러 가기
              <Arrow />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResultLink;
